import { render, staticRenderFns } from "./FactorialMaterialInformation.vue?vue&type=template&id=620bce72&scoped=true"
import script from "./FactorialMaterialInformation.vue?vue&type=script&lang=js"
export * from "./FactorialMaterialInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620bce72",
  null
  
)

export default component.exports